import { createReducer } from "@reduxjs/toolkit";
import { TimetableTripRoute } from "model/TimetableTripRoute";
import { createTimetableTripRouteAction } from "./store";

export interface TimetableState {
    list: TimetableTripRoute[],
    loading: boolean,
    user?: string
}

const INITIAL_STATE: TimetableState = {
    list: [],
    loading: false
};

export const createTimetableReducer = (state: TimetableState = INITIAL_STATE, action: any) => {
    const timetableAction = createTimetableTripRouteAction();

    state = createReducer(state, builder => {
        builder
        .addCase(timetableAction.getTimetableTripRoute.fulfilled, (state, action) => {
            state.loading = false;
            state.list = action.payload;
        })
        .addCase(timetableAction.getTimetableTripRoute.pending, (state) => {
            state.loading = true;
        })
        .addCase(timetableAction.getTimetableTripRoute.rejected, (state) => {
            state.loading = false;
        })
        .addCase(timetableAction.getTimetableUser.fulfilled, (state, action) => {
            state.user = action.payload;
        })
        .addCase(timetableAction.getTimetableUser.pending, (state) => {
            state.user = undefined;
        })
        .addCase(timetableAction.getTimetableUser.rejected, (state) => {
            state.user = undefined;
        })
    })(state, action);

    return state;
}
